import { Switch } from '@base-ui/react/switch';
import styles from "./YuJaSwitch.module.css";
import {DISABLED_TEXT, ENABLED_TEXT} from "../../utils/constants";

export default function YuJaSwitch({
                                       checked,
                                       onChange,
                                       label=true,
                                       disabled=false,
                                       disabledReason,
                                       enabledText="",
                                       disabledText="",
                                       containerStyle={},
                                       ...props
}) {
    return (
        <label className={styles.Label}>


            {!!label && !!checked && (!!enabledText ? enabledText : ENABLED_TEXT)}
            {!!label && !checked && (!!disabledText ? disabledText : DISABLED_TEXT)}

            <Switch.Root
                disabled={disabled}
                checked={checked}
                className={styles.Switch}
                onCheckedChange={(checked, eDetails) => onChange(checked, eDetails.event)}
                {...props}
            >
                <Switch.Thumb className={styles.Thumb}/>
            </Switch.Root>
        </label>
    );
}